import React from 'react';
import { CheckIcon, LockKeyholeIcon, MonitorSmartphoneIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton, Section } from './Shared';
import { KanjiBackdrop, Seal } from './Ornaments';
const benefits = [{
  icon: MonitorSmartphoneIcon,
  label: 'PDF para leer en tablet o computadora'
}, {
  icon: ZapIcon,
  label: 'Acceso digital'
}, {
  icon: LockKeyholeIcon,
  label: 'Pago seguro con Mercado Pago'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function Pricing() {
  const reduceMotion = useReducedMotion();
  return <Section id="pricing" className="my-12 rounded-2xl border border-stone-200 bg-white shadow-lg" data-id="element-195" data-mp="25t0utnvbij91">
      <KanjiBackdrop glyphs={['書', '庫', '術', '道', '傳']} data-id="element-196" data-mp="20sd5r7qngchg" />
      <div className="mx-auto max-w-2xl text-center" data-id="element-197" data-mp="3h74nmqq661ci">
        <span className="inline-flex items-center gap-2 rounded-full bg-red-700 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-198" data-mp="3h5jr4vkao8c0">
          <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-199" data-mp="3vzymyh8jx933" />
          Oferta de lanzamiento
        </span>
        <h2 className="mt-5 text-3xl font-bold tracking-tight text-stone-900 md:text-5xl" data-id="element-200" data-mp="4sckut1hdeoc">
          TU <span className="text-red-700" data-id="element-201" data-mp="9rz2rfs97j3h">BIBLIOTECA DE ESTUDIO</span> MTC
        </h2>
        <p className="mt-3 text-sm font-semibold uppercase tracking-[0.12em] text-amber-700 md:text-base" data-id="element-202" data-mp="erv5zct4n6hz">
          6 tomos principales + 3 bonus gratuitos
        </p>
        <p className="mt-1 text-sm text-stone-500 md:text-base" data-id="element-203" data-mp="3d74gkbozupah">
          450 páginas en PDF
        </p>
      </div>

      <div className="mx-auto mt-9 max-w-2xl" data-id="element-204" data-mp="3n75120ylnbg9">
        <div className="rounded-xl border-2 border-amber-300 bg-amber-50/40 p-5 shadow-md md:p-7" data-id="element-205" data-mp="3n6da53fy61wb">
          <div className="flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-206" data-mp="3ryn2eq4jbe1r">
            <div className="flex gap-4" data-id="element-207" data-mp="2uhoevl1koqsh">
              <Seal characters="中醫" className="h-10 w-10 text-[11px]" data-id="element-208" data-mp="2ugn1vb0zxu84" />
              <div data-id="element-209" data-mp="2zfzphxzoz5br">
                <h3 className="text-xl font-bold tracking-tight text-stone-900" data-id="element-210" data-mp="2zfg8qkls2mzb">
                  KIT MEDICINA TRADICIONAL CHINA™
                </h3>
                <p className="mt-3 max-w-lg text-sm font-medium leading-relaxed text-emerald-700" data-id="element-211" data-mp="2mgqizmwvazmz">
                  Una biblioteca visual de estudio para terapeutas y practicantes
                  con formación previa que quieren ampliar sus conocimientos,
                  explorar distintas ramas y llevar su práctica al siguiente nivel.
                </p>
              </div>
            </div>
            <p className="shrink-0 text-left text-3xl font-bold tracking-tight text-red-700 sm:text-right" data-id="element-212" data-mp="23jz3lokg54o7">
              ARS 24.990
            </p>
          </div>
        </div>
        <motion.div animate={reduceMotion ? undefined : {
        y: [0, -2, 0]
      }} transition={{
        duration: 2.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mt-6" data-id="element-213" data-mp="2dhd9wvcnod2s">
          <CTAButton fullWidth className="py-5 md:text-xl" data-id="element-214" data-mp="3ows3rq9kioto">
            → QUIERO MI KIT MTC POR $24.990
          </CTAButton>
        </motion.div>
        <ul className="mt-5 grid gap-2 sm:grid-cols-2" aria-label="Beneficios de compra" data-id="element-215" data-mp="92fmm62gdps">
          {benefits.map(benefit => <li key={benefit.label} className="flex items-center gap-2 rounded-lg border border-stone-200 bg-stone-50 px-3 py-3 text-[11px] font-semibold leading-tight text-stone-700 md:text-xs" data-id="element-216" data-mp="573z387emf1s">
              <CheckIcon className="h-4 w-4 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-217" data-mp="3rirhvn807hmz" />
              <benefit.icon className="h-4 w-4 shrink-0 text-amber-700" aria-hidden="true" data-id="element-218" data-mp="j2yapyzkbiil" />
              {benefit.label}
            </li>)}
        </ul>
      </div>
    </Section>;
}